// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import FeedCategories from '@app/features/feed/state/FeedCategories';
import {isFeedCategoriesEnabled} from '@app/features/feed/utils/FeedUtils';
import {http} from '@app/features/platform/transport/RestTransport';
import {HttpError} from '@app/features/platform/types/EndpointError';
import {Logger} from '@app/features/platform/utils/AppLogger';
import type {FeedCategoryListResponse} from '@fluxer/schema/src/domains/feed/FeedCategorySchemas';

const logger = new Logger('FeedCategoryCommands');

// When the feed page opens, and again only once the list is older than FEED_CATEGORIES_STALE_MS; `force` after the
// server refused a category the list still offered. Nothing is asked while feature_feed_categories is off.
export async function loadCategories({force = false}: {force?: boolean} = {}): Promise<void> {
	if (!isFeedCategoriesEnabled()) return;
	const session = FeedCategories.beginLoad(force);
	if (session === null) return;
	try {
		const response = await http.get<FeedCategoryListResponse>(Endpoints.FEED_CATEGORIES);
		FeedCategories.handleLoaded(session, response.body ?? []);
	} catch (error) {
		logger.warn('Failed to load feed categories:', error);
		FeedCategories.handleLoadFailed(
			session,
			error instanceof HttpError && error.status === 403 ? 'forbidden' : 'error',
		);
	}
}
